<template>
  <b-overlay :show="show">
    <div class="my-register-page" style="font-size: 13px">
      <div class="my-container">
        <!-- Collapse A: 1-7 punkts (inspection info, read-only) -->
        <div class="collapseCard mb-3 mt-4">
          <div class="collapseHeader" v-b-toggle.collapse-info>
            <h5 class="styleText mb-0">{{ $t("inspectionMainInfo") }}</h5>
            <b-icon
              :icon="infoVisible ? 'chevron-up' : 'chevron-down'"
              font-scale="1.2"
            ></b-icon>
          </div>
          <b-collapse id="collapse-info" v-model="infoVisible">
            <div class="collapseBody">
        <div class="cardStyleEdit mb-3 pt-2">
          <b-row>
            <b-col>
              <h5 class="styleText">1 - {{ $t("punkt") }}</h5>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col cols="12" sm="12" md="6">
              <custom-input
                disabled
                :placeholder="$t('orderCode')"
                v-model="Request.orderCode"
                :label="$t('orderCode')"
              ></custom-input>
            </b-col>
          </b-row>
        </div>
        <div class="cardStyleEdit mb-3">
          <b-row>
            <b-col>
              <h5 class="styleText">2 - {{ $t("punkt") }}</h5>
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col cols="12" sm="6" md="6" class="mb-3">
              <v-select
                disabled
                :placeholder="$t('orderedOrganization')"
                class="my-select"
                :options="ParentList"
                :reduce="(item) => item.value"
                label="text"
                v-model="Request.orderedOrganizationId"
              ></v-select>
            </b-col>
            <b-col cols="12" sm="6" md="6" class="mb-3">
              <v-select
                disabled
                :placeholder="$t('inspectionOrganization')"
                class="my-select"
                :options="OrganizationList"
                :reduce="(item) => item.value"
                label="text"
                v-model="Request.inspectionOrganizationId"
              ></v-select>
            </b-col>
            <b-col cols="12" sm="12" md="6">
              <custom-input-white
                disabled
                :placeholder="$t('inspectionOrganizationAddres')"
                v-model="Request.contractorAddres"
                :label="$t('inspectionOrganizationAddres')"
              ></custom-input-white>
            </b-col>
            <b-col cols="12" sm="12" md="6">
              <custom-input-white
                disabled
                :placeholder="$t('inspectionOrganizationName')"
                v-model="Request.inspectionOrganizationName"
                :label="$t('inspectionOrganizationName')"
              ></custom-input-white>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col cols="12" sm="12" md="6">
              <custom-input-white
                disabled
                :placeholder="$t('inspectionOrganizationPostalAddres')"
                v-model="Request.inspectionOrganizationAddres"
                :label="$t('inspectionOrganizationPostalAddres')"
              ></custom-input-white>
            </b-col>
            <b-col cols="12" sm="12" md="6">
              <custom-input-white
                disabled
                :placeholder="$t('inspectionOrganizationCeo')"
                v-model="Request.inspectionOrganizationCeo"
                :label="$t('inspectionOrganizationCeo')"
              ></custom-input-white>
            </b-col>
          </b-row>
        </div>
        <div class="cardStyleEdit mb-3">
          <b-row>
            <b-col class="mt-2 mb-2" style="text-align: left">
              <h5 class="styleText">3 - {{ $t("punkt") }}</h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-table-simple bordered responsive>
                <b-tbody>
                  <b-tr variant="primary">
                    <b-td colspan="6" class="text-center">
                      <span style="font-size: 18px; font-weight: bold">{{
                        $t("inspectors")
                      }}</span>
                    </b-td>
                  </b-tr>
                  <b-tr variant="primary">
                    <b-td>
                      <span style="font-size: 14px; font-weight: bold">
                        {{ $t("employeeName") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("dutyNumberInspector1") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("dutyExpirationInspector") }}
                      </span>
                    </b-td>
                    <b-td>
                      <span style="font-size: 14px; font-weight: bold">
                        {{ $t("certificateNumber1") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("certificateExpiration1") }}
                      </span>
                    </b-td>
                  </b-tr>
                  <b-tr
                    style="background-color: white"
                    v-for="(item, index) in Request.inspectors"
                    :key="index"
                  >
                    <b-td>
                      {{ item.fullName }}
                    </b-td>
                    <b-td class="text-right">
                      <p>{{ item.dutyNumber }}</p>
                    </b-td>
                    <b-td>
                      <p>{{ item.dutyExpiration }}</p>
                    </b-td>
                    <b-td class="text-right">
                      <p>{{ item.certificateNumber }}</p>
                    </b-td>
                    <b-td>
                      <p>{{ item.certificateExpiration }}</p>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-col>
          </b-row>
        </div>
        <div class="cardStyleEdit mb-3">
          <b-row>
            <b-col class="mt-2 mb-2" style="text-align: left">
              <h5 class="styleText">4 - {{ $t("punkt") }}</h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-table-simple bordered responsive>
                <b-tbody>
                  <b-tr variant="primary">
                    <b-td colspan="10" class="text-center">
                      <span style="font-size: 18px; font-weight: bold">{{
                        $t("involvedInspectors")
                      }}</span>
                    </b-td>
                  </b-tr>
                  <b-tr variant="primary">
                    <b-td>
                      <span style="font-size: 14px; font-weight: bold">
                        {{ $t("organizationName") }}
                      </span>
                    </b-td>
                    <b-td>
                      <span style="font-size: 14px; font-weight: bold">
                        {{ $t("addressEmail") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("inspectorFullName") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("dutyNumberInspector") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("dutyExpirationInspector") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("dutyIssuingOrganization") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("certificateNumber") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("certificateIssuingOrganization") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("certificateExpiration") }}
                      </span>
                    </b-td>
                  </b-tr>
                  <b-tr
                    style="background-color: white"
                    v-for="(item, index) in Request.involvedInspectors"
                    :key="index"
                  >
                    <b-td>
                      {{ item.organizationName }}
                    </b-td>

                    <b-td>
                      {{ item.address }}
                    </b-td>
                    <b-td>
                      {{ item.inspectorFullName }}
                    </b-td>

                    <b-td>
                      {{ item.dutyNumber }}
                    </b-td>
                    <b-td>
                      {{ item.dutyExpiration }}
                    </b-td>

                    <b-td>
                      {{ item.dutyIssuingOrganization }}
                    </b-td>
                    <b-td>
                      {{ item.certificateNumber }}
                    </b-td>

                    <b-td>
                      {{ item.certificateIssuingOrganization }}
                    </b-td>
                    <b-td>
                      {{ item.certificateExpiration }}
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-table-simple bordered responsive>
                <b-tbody>
                  <b-tr variant="primary">
                    <b-td colspan="8" class="text-center">
                      <span style="font-size: 18px; font-weight: bold">{{
                        $t("InvolvedAuditors")
                      }}</span>
                    </b-td>
                  </b-tr>
                  <b-tr variant="primary">
                    <b-td>
                      <span style="font-size: 14px; font-weight: bold">
                        {{ $t("organizationNameAuditor") }}
                      </span>
                    </b-td>
                    <b-td>
                      <span style="font-size: 14px; font-weight: bold">
                        {{ $t("licenseDate") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("licenseNumber") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("licenseExpiration") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("auditorFullName") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("contractNumber") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("contractExpiration") }}
                      </span>
                    </b-td>
                  </b-tr>
                  <b-tr
                    style="background-color: white"
                    v-for="(item, index) in Request.involvedAuditors"
                    :key="index"
                  >
                    <b-td>
                      {{ item.organizationName }}
                    </b-td>

                    <b-td>
                      {{ item.licenseDate }}
                    </b-td>
                    <b-td>
                      {{ item.licenseNumber }}
                    </b-td>
                    <b-td>
                      {{ item.licenseExpiration }}
                    </b-td>
                    <b-td>
                      {{ item.auditorFullName }}
                    </b-td>
                    <b-td>
                      {{ item.contractNumber }}
                    </b-td>
                    <b-td>
                      {{ item.contractExpiration }}
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-table-simple bordered responsive>
                <b-tbody>
                  <b-tr variant="primary">
                    <b-td colspan="5" class="text-center">
                      <span style="font-size: 18px; font-weight: bold">{{
                        $t("specialists")
                      }}</span>
                    </b-td>
                  </b-tr>
                  <b-tr variant="primary">
                    <b-td>
                      <span style="font-size: 14px; font-weight: bold">
                        {{ $t("inspectorsName") }}
                      </span>
                    </b-td>
                    <b-td>
                      <span style="font-size: 14px; font-weight: bold">
                        {{ $t("contractNumber") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("identificationDocument") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("contractExpiration") }}
                      </span>
                    </b-td>
                  </b-tr>
                  <b-tr
                    style="background-color: white"
                    v-for="(item, index) in Request.specialists"
                    :key="index"
                  >
                    <b-td>
                      {{ item.fullName }}
                    </b-td>

                    <b-td>
                      {{ item.contractNumber }}
                    </b-td>
                    <b-td>
                      {{ item.identificationDocument }}
                    </b-td>

                    <b-td>
                      {{ item.contractExpiration }}
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-col>
          </b-row>
        </div>
        <div class="cardStyleEdit mb-3">
          <b-row>
            <b-col>
              <h5 class="styleText">5 - {{ $t("punkt") }}</h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" sm="12" md="4" class="mb-3">
              <custom-input-white
                class="inputStyle"
                disabled
                v-mask="'###-###-###'"
                :placeholder="$t('docNumber5')"
                v-model="Request.docNumber"
                :label="$t('docNumber5')"
              ></custom-input-white>
            </b-col>
            <b-col cols="12" sm="12" md="4" class="mb-3">
              <custom-input-white
                class="inputStyle"
                disabled
                :placeholder="$t('orderNumber5')"
                v-model="Request.orderNumber"
                :label="$t('orderNumber5')"
              ></custom-input-white>
            </b-col>
            <b-col cols="12" sm="12" md="4" class="mb-3">
              <custom-date-picker
                disabled
                :label="$t('orderDate5')"
                placeholder="00.00.0000"
                v-model="Request.orderDate"
              ></custom-date-picker>
            </b-col>
            <b-col cols="12" sm="12" md="12">
              <custom-textarea
                class="inputStyle"
                disabled
                :placeholder="$t('criminalCaseInfo')"
                v-model="Request.criminalCaseInfo"
                :label="$t('criminalCaseInfo')"
              ></custom-textarea>
            </b-col>
          </b-row>
        </div>
        <div class="cardStyleEdit mb-3">
          <b-row>
            <b-col>
              <h5 class="styleText">6 - {{ $t("punkt") }}</h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" sm="12" md="12">
              <v-select
                disabled
                multiple
                :placeholder="$t('controlFunctions')"
                class="my-select"
                :options="ControlFunctionList"
                :reduce="(item) => item.value"
                label="text"
                v-model="Request.controlFunctionNames"
              ></v-select>
            </b-col>
          </b-row>
        </div>
        <div class="cardStyleEdit mb-3">
          <b-row>
            <b-col>
              <h5 class="styleText">7 - {{ $t("punkt") }}</h5>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col cols="12" sm="12" md="4">
              <custom-date-picker
                disabled
                :label="$t('startDate')"
                placeholder="00.00.0000"
                v-model="Request.startDate"
              ></custom-date-picker>
            </b-col>

            <b-col cols="12" sm="12" md="4">
              <custom-date-picker
                disabled
                :label="$t('endDate')"
                placeholder="00.00.0000"
                v-model="Request.endDate"
              ></custom-date-picker>
            </b-col>

            <b-col cols="12" sm="12" md="4">
              <custom-input-white
                disabled
                placeholder="0"
                v-model="Request.checkDaysNumber"
                :label="$t('checkDaysNumber')"
              ></custom-input-white>
            </b-col>
          </b-row>
        </div>
            </div>
          </b-collapse>
        </div>
        <!-- Collapse B: 8-12 punkts (to fill) + rating -->
        <div class="collapseCard mb-3">
          <div class="collapseHeader" v-b-toggle.collapse-fill>
            <h5 class="styleText mb-0">{{ $t("contractorFillPart") }}</h5>
            <b-icon
              :icon="fillVisible ? 'chevron-up' : 'chevron-down'"
              font-scale="1.2"
            ></b-icon>
          </div>
          <b-collapse id="collapse-fill" v-model="fillVisible">
            <div class="collapseBody">
        <div class="cardStyleEdit mb-3">
          <b-row>
            <b-col>
              <h5 class="styleText">8 - {{ $t("punkt") }}</h5>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col cols="12" sm="12" md="4">
              <custom-date-picker
                :label="$t('contractorStartDate')"
                placeholder="00.00.0000"
                v-model="Request.contractorStartDate"
                :disabled-date="disableContractorStartDate"
                @change="onContractorStartDateChange"
              ></custom-date-picker>
            </b-col>

            <b-col cols="12" sm="12" md="4">
              <custom-date-picker
                :label="$t('contractorEndDate')"
                placeholder="00.00.0000"
                v-model="Request.contractorEndDate"
                :disabled-date="disableContractorEndDate"
                @change="onContractorEndDateChange"
              ></custom-date-picker>
            </b-col>
          </b-row>
        </div>
        <div class="cardStyleEdit mb-3">
          <b-row>
            <b-col>
              <h5 class="styleText">9 - {{ $t("punkt") }}</h5>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col cols="12" sm="12" md="4">
              <custom-input-white
                placeholder="0"
                v-model="Request.contractorCheckDaysNumber"
                :label="$t('ContractorCheckDaysNumber')"
              ></custom-input-white>
            </b-col>
          </b-row>
        </div>
        <div class="cardStyleEdit mb-3">
          <b-row>
            <b-col>
              <h5 class="styleText">10 - {{ $t("punkt") }}</h5>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col cols="12" sm="12" md="12">
              <custom-textarea
                :placeholder="$t('requestedDocuments')"
                v-model="Request.requestedDocuments"
                :label="$t('requestedDocuments')"
              ></custom-textarea>
            </b-col>
          </b-row>
        </div>
        <div class="cardStyleEdit mb-3">
          <b-row>
            <b-col>
              <h5 class="styleText">11 - {{ $t("punkt") }}</h5>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col cols="12" sm="12" md="12">
              <custom-textarea
                :placeholder="$t('takenMeasures')"
                v-model="Request.takenMeasures"
                :label="$t('takenMeasures')"
              ></custom-textarea>
            </b-col>
          </b-row>
        </div>
        <div class="cardStyleEdit mb-3">
          <b-row>
            <b-col>
              <h5 class="styleText">12 - {{ $t("punkt") }}</h5>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col cols="12" sm="12" md="12">
              <custom-textarea
                :placeholder="$t('thirdPartyInfo')"
                v-model="Request.thirdPartyInfo"
                :label="$t('thirdPartyInfo')"
              ></custom-textarea>
            </b-col>
          </b-row>
        </div>
        <section v-if="Request.docNumber" class="rt-card mb-3">
          <div class="rt-card-head">
            <h5 class="rt-card-title">{{ $t("Rating") }}</h5>
            <span class="rt-hint">{{ $t("RatingStep2Hint") }}</span>
          </div>
          <div class="rt-card-body">
            <div v-if="rating.alreadyRated" class="rt-already">
              <b-icon icon="check-circle-fill"></b-icon>
              {{ $t("RatingAlreadySubmitted") || "Baholash yuborilgan" }}
            </div>

            <!-- Inspection process rating -->
            <div class="rt-rate-block">
              <div class="rt-who">
                <div class="rt-who-icon"><b-icon icon="clipboard-check"></b-icon></div>
                <div>
                  <div class="rt-who-lbl">
                    {{ $t("InspectionProcess") || "Tekshiruv jarayoni" }}
                  </div>
                  <div class="rt-who-nm">{{ Request.docNumber }}</div>
                </div>
              </div>
              <div class="rt-stars">
                <button
                  v-for="n in 5"
                  :key="'i' + n"
                  type="button"
                  class="rt-star"
                  :class="{ filled: n <= rating.inspectionRating }"
                  :disabled="rating.alreadyRated || rating.submitting"
                  @click="rating.alreadyRated || (rating.inspectionRating = n)"
                >
                  <b-icon icon="star-fill"></b-icon>
                </button>
                <strong class="rt-stars-val">{{ rating.inspectionRating }} / 5</strong>
              </div>
              <textarea
                v-model="rating.inspectionComment"
                class="rt-comment"
                maxlength="500"
                :disabled="rating.alreadyRated || rating.submitting"
                :placeholder="$t('InspectionCommentPh')"
              ></textarea>
            </div>

            <!-- Inspectors rating -->
            <div v-if="rating.inspectors.length" class="rt-rate-block">
              <div class="rt-who">
                <div class="rt-who-icon"><b-icon icon="people-fill"></b-icon></div>
                <div>
                  <div class="rt-who-lbl">
                    {{
                      $t("InspectorsInThisInspection") ||
                        "Tekshiruvda qatnashgan tekshiruvchilar"
                    }}
                  </div>
                  <div class="rt-who-nm">
                    {{ $t("RateAllInspectorsTogether") || "Hammasi uchun umumiy baho" }}
                  </div>
                </div>
              </div>
              <ul class="rt-insp-names">
                <li v-for="(nm, idx) in rating.inspectors" :key="'ins-' + idx">
                  <b-icon icon="person"></b-icon> {{ nm }}
                </li>
              </ul>
              <div class="rt-stars">
                <button
                  v-for="n in 5"
                  :key="'all' + n"
                  type="button"
                  class="rt-star"
                  :class="{ filled: n <= rating.inspectorsRating }"
                  :disabled="rating.alreadyRated || rating.submitting"
                  @click="rating.alreadyRated || (rating.inspectorsRating = n)"
                >
                  <b-icon icon="star-fill"></b-icon>
                </button>
                <strong class="rt-stars-val">{{ rating.inspectorsRating }} / 5</strong>
              </div>
              <textarea
                v-model="rating.inspectorsComment"
                class="rt-comment"
                maxlength="500"
                :disabled="rating.alreadyRated || rating.submitting"
                :placeholder="$t('InspectorCommentPh')"
              ></textarea>
            </div>
          </div>
        </section>
            </div>
          </b-collapse>
        </div>
        <b-row class="mb-3">
          <b-col col="6">
              <!-- <b-button
                @click="back"
                style="width: 150px"
                variant="outline-danger"
              >
                {{ $t("back") }}
              </b-button> -->
          </b-col>
          <b-col col="6" style="text-align: right">
            <b-button
              v-if="Request.statusId === 1"
              :disabled="isSave"
              @click="SaveData"
              style="width: 150px"
              variant="outline-success"
            >
              <b-spinner style="margin-right: 8px" v-if="isSave" small></b-spinner>
              {{ $t("save") }}
            </b-button>
          </b-col>
        </b-row>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import InspectionBookService from "@/services/inspectionbook.service";
import RequestRatingService from "@/services/requestrating.service";
import customDatePicker from "../../components/customDatePickerWhite.vue";
import customInput from "../../components/elements/customInput.vue";
import customInputWhite from "../../components/customInputWhite.vue";
import customSelect from "../../components/customSelectWhite.vue";
import vSelect from "vue-select";
import "bootstrap-vue/dist/bootstrap-vue.css";
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BBadge,
  BSpinner,
  BTableSimple,
  BThead,
  BTbody,
  BTr,
  BTh,
  BTd,
  BOverlay,
  BFormRating,
  BModal,
  BLink,
} from "bootstrap-vue";
import customTextarea from "../../components/customTextareaWhite.vue";
import ControlFunctionService from "@/services/controlfunction.service";
import ManualService from "@/services/manual.service";
export default {
  data() {
    return {
      Request: {},
      ControlFunctionList: [],
      filter: {},
      show: false,
      isSave: false,
      ParentList: [],
      OrganizationList: [],
      infoVisible: false,
      fillVisible: true,
      rating: {
        loaded: false,
        loading: false,
        submitting: false,
        alreadyRated: false,
        inspectors: [],
        inspectionRating: 0,
        inspectionComment: "",
        inspectorsRating: 0,
        inspectorsComment: "",
      },
    };
  },
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BBadge,
    BSpinner,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BOverlay,
    customDatePicker,
    customInput,
    BFormRating,
    customTextarea,
    vSelect,
    BModal,
    BLink,
    customInputWhite,
    customSelect,
  },
  created() {
    this.Refresh();

    ManualService.GetOrganizationAsSelectList("", false, true).then((res) => {
      this.ParentList = res.data;
    });
  },
  methods: {
    Refresh() {
      this.show = true;
      InspectionBookService.Get(this.$route.params.id)
        .then((res) => {
          this.Request = res.data;
          this.show = false;
          if (this.Request && this.Request.docNumber) {
            this.loadRating(this.Request.docNumber);
          }
          ManualService.GetOrganizationAsSelectList(
            this.Request.orderedOrganizationId,
            false,
            true
          ).then((res) => {
            this.OrganizationList = res.data;
          });
          if (!!this.Request.inspectionOrganizationId) {
            this.Request.inspectionOrganizationName = this.OrganizationList.filter(
              (item) => item.value === this.Request.inspectionOrganizationId
            )[0].text;
            ControlFunctionService.GetAsSelectList(
              this.Request.orderedOrganizationId
            ).then((res) => {
              this.ControlFunctionList = res.data;
            });
          }
        })
        .catch((error) => {
          this.makeToast(error.response.data, "error");
          this.show = false;
        });
    },
    parseDate(str) {
      if (!str || typeof str !== "string") return null;
      var arr = str.split(".");
      if (arr.length !== 3 || arr[2].length !== 4) return null;
      var d = new Date(Number(arr[2]), Number(arr[1]) - 1, Number(arr[0]));
      return isNaN(d.getTime()) ? null : d;
    },
    // Calendar: disable start days that fall after the end date.
    disableContractorStartDate(date) {
      var end = this.parseDate(this.Request.contractorEndDate);
      if (!end) return false;
      return date > end;
    },
    // Calendar: disable end days that fall before the start date.
    disableContractorEndDate(date) {
      var start = this.parseDate(this.Request.contractorStartDate);
      if (!start) return false;
      return date < start;
    },
    // Manual typing guard: clear the field if the range becomes invalid.
    onContractorStartDateChange() {
      var start = this.parseDate(this.Request.contractorStartDate);
      var end = this.parseDate(this.Request.contractorEndDate);
      if (start && end && start > end) {
        this.Request.contractorStartDate = "";
        this.makeToast(this.$t("dateRangeInvalid"), "error");
      }
    },
    onContractorEndDateChange() {
      var start = this.parseDate(this.Request.contractorStartDate);
      var end = this.parseDate(this.Request.contractorEndDate);
      if (start && end && end < start) {
        this.Request.contractorEndDate = "";
        this.makeToast(this.$t("dateRangeInvalid"), "error");
      }
    },
    SaveData() {
      this.isSave = true;
      InspectionBookService.Update(this.Request)
        .then(() => {
          // Tie the rating to the document save: send the rating(s) too.
          return this.submitRatingOnSave();
        })
        .then(() => {
          this.isSave = false;
          this.makeToast(this.$t("SaveSuccess"), "success");
          this.$router.push({ name: "inspectionbookcombined" });
        })
        .catch((error) => {
          this.isSave = false;
          this.makeToast(error.response.data, "error");
        });
    },
    loadRating(docNumber) {
      this.rating.loading = true;
      RequestRatingService.GetByDocNumber(docNumber)
        .then((res) => {
          const d = (res && res.data) || {};
          const names = Array.isArray(d.inspectorNames) ? d.inspectorNames : [];
          this.rating.inspectors = names;
          return RequestRatingService.GetList({
            search: docNumber,
            sortBy: "",
            orderType: "",
            page: 1,
            pageSize: 20,
          })
            .then((r) => {
              const rows = (r && r.data && (r.data.rows || r.data.items)) || [];
              const own = rows.filter((x) => x.docNumber === docNumber);
              if (own.length) {
                this.rating.alreadyRated = true;
                const req = own.find((x) => x.isRequest);
                const ins = own.find((x) => !x.isRequest);
                if (req) {
                  this.rating.inspectionRating = req.rating || 0;
                  this.rating.inspectionComment = req.text || "";
                }
                if (ins) {
                  this.rating.inspectorsRating = ins.rating || 0;
                  this.rating.inspectorsComment = ins.text || "";
                }
              }
            })
            .catch(() => {
              /* ignore — assume not rated */
            });
        })
        .catch(() => {
          /* docNumber lookup failed — leave inspectors empty */
        })
        .finally(() => {
          this.rating.loading = false;
          this.rating.loaded = true;
        });
    },
    submitRatingOnSave() {
      // Nothing to send if there is no docNumber, already rated, or no score given.
      if (!this.Request.docNumber) return Promise.resolve();
      if (this.rating.alreadyRated) return Promise.resolve();
      if (this.rating.inspectionRating < 1) return Promise.resolve();
      this.rating.submitting = true;
      const docNumber = this.Request.docNumber;
      const payloads = [
        {
          docNumber: docNumber,
          rating: this.rating.inspectionRating,
          isRequest: true,
          ratingTypeId: 1,
          text: this.rating.inspectionComment || "",
        },
      ];
      if (this.rating.inspectors.length && this.rating.inspectorsRating > 0) {
        payloads.push({
          docNumber: docNumber,
          rating: this.rating.inspectorsRating,
          isRequest: false,
          ratingTypeId: 2,
          text: this.rating.inspectorsComment || "",
        });
      }
      return Promise.all(payloads.map((p) => RequestRatingService.Create(p)))
        .then(() => {
          this.rating.alreadyRated = true;
        })
        .catch(() => {
          /* rating failed — don't block the document save success */
        })
        .finally(() => {
          this.rating.submitting = false;
        });
    },
    back() {
      this.$router.go(-1);
    },
    makeToast(message, type) {
      var a = "";
      if (message.status == 500) {
        a = message.title;
      }
      if (message.status == 400) {
        var errors = Object.values(message.errors);
        var a = errors.map((el, item) => item + 1 + "." + el).join("\n");
      } else {
        a = message;
      }
      this.$toast.open({
        message: a,
        type: type,
        duration: 5000,
        dismissible: true,
      });
    },
  },
};
</script>

<style>
.backColor {
  background-color: #f3f1f1 !important;
}
.vs__dropdown-toggle {
  background-color: white !important;
}
.v-toast__item--Error {
  background-color: red;
}
.v-toast__item--success {
  background-color: green;
}
.cardStyleEdit {
  padding: 5px;
  background-color: #eaf2ff;
  border-radius: 5px;
}
.collapseCard {
  padding: 5px;
  background-color: #dbe7ff;
  border-radius: 5px;
}
.collapseHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 10px 8px;
  user-select: none;
}
.collapseBody {
  padding: 4px 4px 0;
}
/* Rating block */
.rt-card {
  background: #fff;
  border: 1px solid #e3e6ee;
  border-radius: 14px;
  overflow: hidden;
}
.rt-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid #eef0f5;
  gap: 12px;
  flex-wrap: wrap;
}
.rt-card-title {
  font-size: 16px;
  font-weight: 800;
  margin: 0;
  color: #1c2238;
}
.rt-hint {
  font-size: 12px;
  color: #6b7388;
}
.rt-card-body {
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.rt-already {
  background: #d1fae5;
  color: #065f46;
  padding: 10px 14px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.rt-rate-block {
  padding: 14px;
  background: #f8f9fc;
  border-radius: 12px;
  border: 1px solid #eef0f5;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.rt-who {
  display: flex;
  align-items: center;
  gap: 12px;
}
.rt-who-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: #eef2fb;
  color: #2a3b5d;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}
.rt-who-lbl {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: #8a92a8;
}
.rt-who-nm {
  font-size: 14px;
  font-weight: 700;
  color: #1c2238;
}
.rt-insp-names {
  list-style: none;
  margin: 0;
  padding: 10px 14px;
  background: #fff;
  border-radius: 10px;
  border: 1px solid #eef0f5;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.rt-insp-names li {
  font-size: 13px;
  color: #1c2238;
  display: flex;
  align-items: center;
  gap: 8px;
}
.rt-insp-names li svg {
  color: #2a3b5d;
}
.rt-stars {
  display: flex;
  align-items: center;
  gap: 4px;
}
.rt-star {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: #d9dde6;
  font-size: 22px;
  line-height: 1;
  display: inline-flex;
  transition: color 0.15s;
}
.rt-star:hover:not(:disabled) {
  color: #f5b800;
}
.rt-star.filled {
  color: #f5b800;
}
.rt-star:disabled {
  cursor: default;
  opacity: 0.85;
}
.rt-stars-val {
  margin-left: 8px;
  font-size: 13px;
  color: #4a526a;
  font-weight: 700;
}
.rt-comment {
  width: 100%;
  border: 1.5px solid #e3e6ee;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 13px;
  font-family: inherit;
  min-height: 70px;
  resize: vertical;
  outline: none;
  background: #fff;
  color: #1c2238;
}
.rt-comment:focus {
  border-color: #2a3b5d;
}
.rt-comment:disabled {
  background: #f8f9fc;
  color: #4a526a;
}
.styleText {
  font-weight: 900;
}
.my-select .vs__dropdown-toggle {
  padding: 12px 10px !important;
  border: none;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  background-color: #f7f7f7;
}
</style>
